module.exports = __webpack_public_path__ + "static/media/pic_qjwl.aba722e3.png";